export default "__VITE_ASSET__AEoAXqmm__"